export default "__VITE_ASSET__BOzLtgHB__"